import e from "../../../constants/screen.js";
const a = {
  props: {
    /**
         * Component's screen
         * Possible values are: 'small', 'medium', 'large'
         */
    screen: {
      type: String,
      default: e.small.name,
      validator: (r) => [e.small.name, e.medium.name, e.large.name].includes(r)
    }
  },
  computed: {
    isScreenLarge() {
      return this.screen === e.large.name;
    },
    isScreenMedium() {
      return this.screen === e.medium.name;
    },
    isScreenSmall() {
      return this.screen === e.small.name;
    }
  }
};
export {
  a as default
};
